/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ApplicationRouteRouteImport } from './routes/application/route'
import { Route as MerchantRouteRouteImport } from './routes/_merchant/route'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as ApplicationIndexRouteImport } from './routes/application/index'
import { Route as MerchantPasswordRouteImport } from './routes/_merchant/password'
import { Route as ApplicationIdRouteRouteImport } from './routes/application/$id.route'
import { Route as MerchantApplyRouteRouteImport } from './routes/_merchant/apply/route'
import { Route as MerchantPortalRouteRouteImport } from './routes/_merchant/_portal/route'
import { Route as publicLoginRouteRouteImport } from './routes/(public)/login/route'
import { Route as publicApplyRouteRouteImport } from './routes/(public)/apply/route'
import { Route as ApplicationIdIndexRouteImport } from './routes/application/$id.index'
import { Route as MerchantApplyIndexRouteImport } from './routes/_merchant/apply/index'
import { Route as MerchantPortalIndexRouteImport } from './routes/_merchant/_portal/index'
import { Route as publicLoginIndexRouteImport } from './routes/(public)/login/index'
import { Route as ApplicationIdRenewalRouteImport } from './routes/application/$id.renewal'
import { Route as ApplicationIdOfferRouteImport } from './routes/application/$id.offer'
import { Route as ApplicationIdCheckoutRouteImport } from './routes/application/$id.checkout'
import { Route as ApplicationIdApplyRouteImport } from './routes/application/$id.apply'
import { Route as MerchantPortalProfileRouteImport } from './routes/_merchant/_portal/profile'
import { Route as MerchantPortalPaymentRouteImport } from './routes/_merchant/_portal/payment'
import { Route as MerchantPortalInstantfundingRouteImport } from './routes/_merchant/_portal/instantfunding'
import { Route as MerchantPortalDrawfundsRouteImport } from './routes/_merchant/_portal/drawfunds'
import { Route as MerchantPortalDocumentsRouteImport } from './routes/_merchant/_portal/documents'
import { Route as MerchantPortalBusinessRouteImport } from './routes/_merchant/_portal/business'
import { Route as publicLoginOtpRouteImport } from './routes/(public)/login/otp'
import { Route as publicApplyLandingRouteImport } from './routes/(public)/apply/landing'
import { Route as publicLoginMobileRouteRouteImport } from './routes/(public)/login/mobile/route'
import { Route as publicLoginMobileIndexRouteImport } from './routes/(public)/login/mobile/index'
import { Route as publicLoginMobileCompleteRouteImport } from './routes/(public)/login/mobile/complete'

const ApplicationRouteRoute = ApplicationRouteRouteImport.update({
  id: '/application',
  path: '/application',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantRouteRoute = MerchantRouteRouteImport.update({
  id: '/_merchant',
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationIndexRoute = ApplicationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApplicationRouteRoute,
} as any)
const MerchantPasswordRoute = MerchantPasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => MerchantRouteRoute,
} as any)
const ApplicationIdRouteRoute = ApplicationIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ApplicationRouteRoute,
} as any)
const MerchantApplyRouteRoute = MerchantApplyRouteRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => MerchantRouteRoute,
} as any)
const MerchantPortalRouteRoute = MerchantPortalRouteRouteImport.update({
  id: '/_portal',
  getParentRoute: () => MerchantRouteRoute,
} as any)
const publicLoginRouteRoute = publicLoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicApplyRouteRoute = publicApplyRouteRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => publicRouteRoute,
} as any)
const ApplicationIdIndexRoute = ApplicationIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApplicationIdRouteRoute,
} as any)
const MerchantApplyIndexRoute = MerchantApplyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MerchantApplyRouteRoute,
} as any)
const MerchantPortalIndexRoute = MerchantPortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MerchantPortalRouteRoute,
} as any)
const publicLoginIndexRoute = publicLoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicLoginRouteRoute,
} as any)
const ApplicationIdRenewalRoute = ApplicationIdRenewalRouteImport.update({
  id: '/renewal',
  path: '/renewal',
  getParentRoute: () => ApplicationIdRouteRoute,
} as any)
const ApplicationIdOfferRoute = ApplicationIdOfferRouteImport.update({
  id: '/offer',
  path: '/offer',
  getParentRoute: () => ApplicationIdRouteRoute,
} as any)
const ApplicationIdCheckoutRoute = ApplicationIdCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => ApplicationIdRouteRoute,
} as any)
const ApplicationIdApplyRoute = ApplicationIdApplyRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => ApplicationIdRouteRoute,
} as any)
const MerchantPortalProfileRoute = MerchantPortalProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MerchantPortalRouteRoute,
} as any)
const MerchantPortalPaymentRoute = MerchantPortalPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => MerchantPortalRouteRoute,
} as any)
const MerchantPortalInstantfundingRoute =
  MerchantPortalInstantfundingRouteImport.update({
    id: '/instantfunding',
    path: '/instantfunding',
    getParentRoute: () => MerchantPortalRouteRoute,
  } as any)
const MerchantPortalDrawfundsRoute = MerchantPortalDrawfundsRouteImport.update({
  id: '/drawfunds',
  path: '/drawfunds',
  getParentRoute: () => MerchantPortalRouteRoute,
} as any)
const MerchantPortalDocumentsRoute = MerchantPortalDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => MerchantPortalRouteRoute,
} as any)
const MerchantPortalBusinessRoute = MerchantPortalBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => MerchantPortalRouteRoute,
} as any)
const publicLoginOtpRoute = publicLoginOtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => publicLoginRouteRoute,
} as any)
const publicApplyLandingRoute = publicApplyLandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => publicApplyRouteRoute,
} as any)
const publicLoginMobileRouteRoute = publicLoginMobileRouteRouteImport.update({
  id: '/mobile',
  path: '/mobile',
  getParentRoute: () => publicLoginRouteRoute,
} as any)
const publicLoginMobileIndexRoute = publicLoginMobileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicLoginMobileRouteRoute,
} as any)
const publicLoginMobileCompleteRoute =
  publicLoginMobileCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => publicLoginMobileRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MerchantPortalIndexRoute
  '/application': typeof ApplicationRouteRouteWithChildren
  '/apply': typeof MerchantApplyRouteRouteWithChildren
  '/login': typeof publicLoginRouteRouteWithChildren
  '/application/$id': typeof ApplicationIdRouteRouteWithChildren
  '/password': typeof MerchantPasswordRoute
  '/application/': typeof ApplicationIndexRoute
  '/login/mobile': typeof publicLoginMobileRouteRouteWithChildren
  '/apply/landing': typeof publicApplyLandingRoute
  '/login/otp': typeof publicLoginOtpRoute
  '/business': typeof MerchantPortalBusinessRoute
  '/documents': typeof MerchantPortalDocumentsRoute
  '/drawfunds': typeof MerchantPortalDrawfundsRoute
  '/instantfunding': typeof MerchantPortalInstantfundingRoute
  '/payment': typeof MerchantPortalPaymentRoute
  '/profile': typeof MerchantPortalProfileRoute
  '/application/$id/apply': typeof ApplicationIdApplyRoute
  '/application/$id/checkout': typeof ApplicationIdCheckoutRoute
  '/application/$id/offer': typeof ApplicationIdOfferRoute
  '/application/$id/renewal': typeof ApplicationIdRenewalRoute
  '/login/': typeof publicLoginIndexRoute
  '/apply/': typeof MerchantApplyIndexRoute
  '/application/$id/': typeof ApplicationIdIndexRoute
  '/login/mobile/complete': typeof publicLoginMobileCompleteRoute
  '/login/mobile/': typeof publicLoginMobileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof MerchantPortalIndexRoute
  '/apply': typeof MerchantApplyIndexRoute
  '/password': typeof MerchantPasswordRoute
  '/application': typeof ApplicationIndexRoute
  '/apply/landing': typeof publicApplyLandingRoute
  '/login/otp': typeof publicLoginOtpRoute
  '/business': typeof MerchantPortalBusinessRoute
  '/documents': typeof MerchantPortalDocumentsRoute
  '/drawfunds': typeof MerchantPortalDrawfundsRoute
  '/instantfunding': typeof MerchantPortalInstantfundingRoute
  '/payment': typeof MerchantPortalPaymentRoute
  '/profile': typeof MerchantPortalProfileRoute
  '/application/$id/apply': typeof ApplicationIdApplyRoute
  '/application/$id/checkout': typeof ApplicationIdCheckoutRoute
  '/application/$id/offer': typeof ApplicationIdOfferRoute
  '/application/$id/renewal': typeof ApplicationIdRenewalRoute
  '/login': typeof publicLoginIndexRoute
  '/application/$id': typeof ApplicationIdIndexRoute
  '/login/mobile/complete': typeof publicLoginMobileCompleteRoute
  '/login/mobile': typeof publicLoginMobileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(public)': typeof publicRouteRouteWithChildren
  '/_merchant': typeof MerchantRouteRouteWithChildren
  '/application': typeof ApplicationRouteRouteWithChildren
  '/(public)/apply': typeof publicApplyRouteRouteWithChildren
  '/(public)/login': typeof publicLoginRouteRouteWithChildren
  '/_merchant/_portal': typeof MerchantPortalRouteRouteWithChildren
  '/_merchant/apply': typeof MerchantApplyRouteRouteWithChildren
  '/application/$id': typeof ApplicationIdRouteRouteWithChildren
  '/_merchant/password': typeof MerchantPasswordRoute
  '/application/': typeof ApplicationIndexRoute
  '/(public)/login/mobile': typeof publicLoginMobileRouteRouteWithChildren
  '/(public)/apply/landing': typeof publicApplyLandingRoute
  '/(public)/login/otp': typeof publicLoginOtpRoute
  '/_merchant/_portal/business': typeof MerchantPortalBusinessRoute
  '/_merchant/_portal/documents': typeof MerchantPortalDocumentsRoute
  '/_merchant/_portal/drawfunds': typeof MerchantPortalDrawfundsRoute
  '/_merchant/_portal/instantfunding': typeof MerchantPortalInstantfundingRoute
  '/_merchant/_portal/payment': typeof MerchantPortalPaymentRoute
  '/_merchant/_portal/profile': typeof MerchantPortalProfileRoute
  '/application/$id/apply': typeof ApplicationIdApplyRoute
  '/application/$id/checkout': typeof ApplicationIdCheckoutRoute
  '/application/$id/offer': typeof ApplicationIdOfferRoute
  '/application/$id/renewal': typeof ApplicationIdRenewalRoute
  '/(public)/login/': typeof publicLoginIndexRoute
  '/_merchant/_portal/': typeof MerchantPortalIndexRoute
  '/_merchant/apply/': typeof MerchantApplyIndexRoute
  '/application/$id/': typeof ApplicationIdIndexRoute
  '/(public)/login/mobile/complete': typeof publicLoginMobileCompleteRoute
  '/(public)/login/mobile/': typeof publicLoginMobileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/application'
    | '/apply'
    | '/login'
    | '/application/$id'
    | '/password'
    | '/application/'
    | '/login/mobile'
    | '/apply/landing'
    | '/login/otp'
    | '/business'
    | '/documents'
    | '/drawfunds'
    | '/instantfunding'
    | '/payment'
    | '/profile'
    | '/application/$id/apply'
    | '/application/$id/checkout'
    | '/application/$id/offer'
    | '/application/$id/renewal'
    | '/login/'
    | '/apply/'
    | '/application/$id/'
    | '/login/mobile/complete'
    | '/login/mobile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/apply'
    | '/password'
    | '/application'
    | '/apply/landing'
    | '/login/otp'
    | '/business'
    | '/documents'
    | '/drawfunds'
    | '/instantfunding'
    | '/payment'
    | '/profile'
    | '/application/$id/apply'
    | '/application/$id/checkout'
    | '/application/$id/offer'
    | '/application/$id/renewal'
    | '/login'
    | '/application/$id'
    | '/login/mobile/complete'
    | '/login/mobile'
  id:
    | '__root__'
    | '/(public)'
    | '/_merchant'
    | '/application'
    | '/(public)/apply'
    | '/(public)/login'
    | '/_merchant/_portal'
    | '/_merchant/apply'
    | '/application/$id'
    | '/_merchant/password'
    | '/application/'
    | '/(public)/login/mobile'
    | '/(public)/apply/landing'
    | '/(public)/login/otp'
    | '/_merchant/_portal/business'
    | '/_merchant/_portal/documents'
    | '/_merchant/_portal/drawfunds'
    | '/_merchant/_portal/instantfunding'
    | '/_merchant/_portal/payment'
    | '/_merchant/_portal/profile'
    | '/application/$id/apply'
    | '/application/$id/checkout'
    | '/application/$id/offer'
    | '/application/$id/renewal'
    | '/(public)/login/'
    | '/_merchant/_portal/'
    | '/_merchant/apply/'
    | '/application/$id/'
    | '/(public)/login/mobile/complete'
    | '/(public)/login/mobile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  publicRouteRoute: typeof publicRouteRouteWithChildren
  MerchantRouteRoute: typeof MerchantRouteRouteWithChildren
  ApplicationRouteRoute: typeof ApplicationRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/application': {
      id: '/application'
      path: '/application'
      fullPath: '/application'
      preLoaderRoute: typeof ApplicationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_merchant': {
      id: '/_merchant'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MerchantRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)': {
      id: '/(public)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/application/': {
      id: '/application/'
      path: '/'
      fullPath: '/application/'
      preLoaderRoute: typeof ApplicationIndexRouteImport
      parentRoute: typeof ApplicationRouteRoute
    }
    '/_merchant/password': {
      id: '/_merchant/password'
      path: '/password'
      fullPath: '/password'
      preLoaderRoute: typeof MerchantPasswordRouteImport
      parentRoute: typeof MerchantRouteRoute
    }
    '/application/$id': {
      id: '/application/$id'
      path: '/$id'
      fullPath: '/application/$id'
      preLoaderRoute: typeof ApplicationIdRouteRouteImport
      parentRoute: typeof ApplicationRouteRoute
    }
    '/_merchant/apply': {
      id: '/_merchant/apply'
      path: '/apply'
      fullPath: '/apply'
      preLoaderRoute: typeof MerchantApplyRouteRouteImport
      parentRoute: typeof MerchantRouteRoute
    }
    '/_merchant/_portal': {
      id: '/_merchant/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MerchantPortalRouteRouteImport
      parentRoute: typeof MerchantRouteRoute
    }
    '/(public)/login': {
      id: '/(public)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicLoginRouteRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/apply': {
      id: '/(public)/apply'
      path: '/apply'
      fullPath: '/apply'
      preLoaderRoute: typeof publicApplyRouteRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/application/$id/': {
      id: '/application/$id/'
      path: '/'
      fullPath: '/application/$id/'
      preLoaderRoute: typeof ApplicationIdIndexRouteImport
      parentRoute: typeof ApplicationIdRouteRoute
    }
    '/_merchant/apply/': {
      id: '/_merchant/apply/'
      path: '/'
      fullPath: '/apply/'
      preLoaderRoute: typeof MerchantApplyIndexRouteImport
      parentRoute: typeof MerchantApplyRouteRoute
    }
    '/_merchant/_portal/': {
      id: '/_merchant/_portal/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MerchantPortalIndexRouteImport
      parentRoute: typeof MerchantPortalRouteRoute
    }
    '/(public)/login/': {
      id: '/(public)/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof publicLoginIndexRouteImport
      parentRoute: typeof publicLoginRouteRoute
    }
    '/application/$id/renewal': {
      id: '/application/$id/renewal'
      path: '/renewal'
      fullPath: '/application/$id/renewal'
      preLoaderRoute: typeof ApplicationIdRenewalRouteImport
      parentRoute: typeof ApplicationIdRouteRoute
    }
    '/application/$id/offer': {
      id: '/application/$id/offer'
      path: '/offer'
      fullPath: '/application/$id/offer'
      preLoaderRoute: typeof ApplicationIdOfferRouteImport
      parentRoute: typeof ApplicationIdRouteRoute
    }
    '/application/$id/checkout': {
      id: '/application/$id/checkout'
      path: '/checkout'
      fullPath: '/application/$id/checkout'
      preLoaderRoute: typeof ApplicationIdCheckoutRouteImport
      parentRoute: typeof ApplicationIdRouteRoute
    }
    '/application/$id/apply': {
      id: '/application/$id/apply'
      path: '/apply'
      fullPath: '/application/$id/apply'
      preLoaderRoute: typeof ApplicationIdApplyRouteImport
      parentRoute: typeof ApplicationIdRouteRoute
    }
    '/_merchant/_portal/profile': {
      id: '/_merchant/_portal/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MerchantPortalProfileRouteImport
      parentRoute: typeof MerchantPortalRouteRoute
    }
    '/_merchant/_portal/payment': {
      id: '/_merchant/_portal/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof MerchantPortalPaymentRouteImport
      parentRoute: typeof MerchantPortalRouteRoute
    }
    '/_merchant/_portal/instantfunding': {
      id: '/_merchant/_portal/instantfunding'
      path: '/instantfunding'
      fullPath: '/instantfunding'
      preLoaderRoute: typeof MerchantPortalInstantfundingRouteImport
      parentRoute: typeof MerchantPortalRouteRoute
    }
    '/_merchant/_portal/drawfunds': {
      id: '/_merchant/_portal/drawfunds'
      path: '/drawfunds'
      fullPath: '/drawfunds'
      preLoaderRoute: typeof MerchantPortalDrawfundsRouteImport
      parentRoute: typeof MerchantPortalRouteRoute
    }
    '/_merchant/_portal/documents': {
      id: '/_merchant/_portal/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof MerchantPortalDocumentsRouteImport
      parentRoute: typeof MerchantPortalRouteRoute
    }
    '/_merchant/_portal/business': {
      id: '/_merchant/_portal/business'
      path: '/business'
      fullPath: '/business'
      preLoaderRoute: typeof MerchantPortalBusinessRouteImport
      parentRoute: typeof MerchantPortalRouteRoute
    }
    '/(public)/login/otp': {
      id: '/(public)/login/otp'
      path: '/otp'
      fullPath: '/login/otp'
      preLoaderRoute: typeof publicLoginOtpRouteImport
      parentRoute: typeof publicLoginRouteRoute
    }
    '/(public)/apply/landing': {
      id: '/(public)/apply/landing'
      path: '/landing'
      fullPath: '/apply/landing'
      preLoaderRoute: typeof publicApplyLandingRouteImport
      parentRoute: typeof publicApplyRouteRoute
    }
    '/(public)/login/mobile': {
      id: '/(public)/login/mobile'
      path: '/mobile'
      fullPath: '/login/mobile'
      preLoaderRoute: typeof publicLoginMobileRouteRouteImport
      parentRoute: typeof publicLoginRouteRoute
    }
    '/(public)/login/mobile/': {
      id: '/(public)/login/mobile/'
      path: '/'
      fullPath: '/login/mobile/'
      preLoaderRoute: typeof publicLoginMobileIndexRouteImport
      parentRoute: typeof publicLoginMobileRouteRoute
    }
    '/(public)/login/mobile/complete': {
      id: '/(public)/login/mobile/complete'
      path: '/complete'
      fullPath: '/login/mobile/complete'
      preLoaderRoute: typeof publicLoginMobileCompleteRouteImport
      parentRoute: typeof publicLoginMobileRouteRoute
    }
  }
}

interface publicApplyRouteRouteChildren {
  publicApplyLandingRoute: typeof publicApplyLandingRoute
}

const publicApplyRouteRouteChildren: publicApplyRouteRouteChildren = {
  publicApplyLandingRoute: publicApplyLandingRoute,
}

const publicApplyRouteRouteWithChildren =
  publicApplyRouteRoute._addFileChildren(publicApplyRouteRouteChildren)

interface publicLoginMobileRouteRouteChildren {
  publicLoginMobileCompleteRoute: typeof publicLoginMobileCompleteRoute
  publicLoginMobileIndexRoute: typeof publicLoginMobileIndexRoute
}

const publicLoginMobileRouteRouteChildren: publicLoginMobileRouteRouteChildren =
  {
    publicLoginMobileCompleteRoute: publicLoginMobileCompleteRoute,
    publicLoginMobileIndexRoute: publicLoginMobileIndexRoute,
  }

const publicLoginMobileRouteRouteWithChildren =
  publicLoginMobileRouteRoute._addFileChildren(
    publicLoginMobileRouteRouteChildren,
  )

interface publicLoginRouteRouteChildren {
  publicLoginMobileRouteRoute: typeof publicLoginMobileRouteRouteWithChildren
  publicLoginOtpRoute: typeof publicLoginOtpRoute
  publicLoginIndexRoute: typeof publicLoginIndexRoute
}

const publicLoginRouteRouteChildren: publicLoginRouteRouteChildren = {
  publicLoginMobileRouteRoute: publicLoginMobileRouteRouteWithChildren,
  publicLoginOtpRoute: publicLoginOtpRoute,
  publicLoginIndexRoute: publicLoginIndexRoute,
}

const publicLoginRouteRouteWithChildren =
  publicLoginRouteRoute._addFileChildren(publicLoginRouteRouteChildren)

interface publicRouteRouteChildren {
  publicApplyRouteRoute: typeof publicApplyRouteRouteWithChildren
  publicLoginRouteRoute: typeof publicLoginRouteRouteWithChildren
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicApplyRouteRoute: publicApplyRouteRouteWithChildren,
  publicLoginRouteRoute: publicLoginRouteRouteWithChildren,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

interface MerchantPortalRouteRouteChildren {
  MerchantPortalBusinessRoute: typeof MerchantPortalBusinessRoute
  MerchantPortalDocumentsRoute: typeof MerchantPortalDocumentsRoute
  MerchantPortalDrawfundsRoute: typeof MerchantPortalDrawfundsRoute
  MerchantPortalInstantfundingRoute: typeof MerchantPortalInstantfundingRoute
  MerchantPortalPaymentRoute: typeof MerchantPortalPaymentRoute
  MerchantPortalProfileRoute: typeof MerchantPortalProfileRoute
  MerchantPortalIndexRoute: typeof MerchantPortalIndexRoute
}

const MerchantPortalRouteRouteChildren: MerchantPortalRouteRouteChildren = {
  MerchantPortalBusinessRoute: MerchantPortalBusinessRoute,
  MerchantPortalDocumentsRoute: MerchantPortalDocumentsRoute,
  MerchantPortalDrawfundsRoute: MerchantPortalDrawfundsRoute,
  MerchantPortalInstantfundingRoute: MerchantPortalInstantfundingRoute,
  MerchantPortalPaymentRoute: MerchantPortalPaymentRoute,
  MerchantPortalProfileRoute: MerchantPortalProfileRoute,
  MerchantPortalIndexRoute: MerchantPortalIndexRoute,
}

const MerchantPortalRouteRouteWithChildren =
  MerchantPortalRouteRoute._addFileChildren(MerchantPortalRouteRouteChildren)

interface MerchantApplyRouteRouteChildren {
  MerchantApplyIndexRoute: typeof MerchantApplyIndexRoute
}

const MerchantApplyRouteRouteChildren: MerchantApplyRouteRouteChildren = {
  MerchantApplyIndexRoute: MerchantApplyIndexRoute,
}

const MerchantApplyRouteRouteWithChildren =
  MerchantApplyRouteRoute._addFileChildren(MerchantApplyRouteRouteChildren)

interface MerchantRouteRouteChildren {
  MerchantPortalRouteRoute: typeof MerchantPortalRouteRouteWithChildren
  MerchantApplyRouteRoute: typeof MerchantApplyRouteRouteWithChildren
  MerchantPasswordRoute: typeof MerchantPasswordRoute
}

const MerchantRouteRouteChildren: MerchantRouteRouteChildren = {
  MerchantPortalRouteRoute: MerchantPortalRouteRouteWithChildren,
  MerchantApplyRouteRoute: MerchantApplyRouteRouteWithChildren,
  MerchantPasswordRoute: MerchantPasswordRoute,
}

const MerchantRouteRouteWithChildren = MerchantRouteRoute._addFileChildren(
  MerchantRouteRouteChildren,
)

interface ApplicationIdRouteRouteChildren {
  ApplicationIdApplyRoute: typeof ApplicationIdApplyRoute
  ApplicationIdCheckoutRoute: typeof ApplicationIdCheckoutRoute
  ApplicationIdOfferRoute: typeof ApplicationIdOfferRoute
  ApplicationIdRenewalRoute: typeof ApplicationIdRenewalRoute
  ApplicationIdIndexRoute: typeof ApplicationIdIndexRoute
}

const ApplicationIdRouteRouteChildren: ApplicationIdRouteRouteChildren = {
  ApplicationIdApplyRoute: ApplicationIdApplyRoute,
  ApplicationIdCheckoutRoute: ApplicationIdCheckoutRoute,
  ApplicationIdOfferRoute: ApplicationIdOfferRoute,
  ApplicationIdRenewalRoute: ApplicationIdRenewalRoute,
  ApplicationIdIndexRoute: ApplicationIdIndexRoute,
}

const ApplicationIdRouteRouteWithChildren =
  ApplicationIdRouteRoute._addFileChildren(ApplicationIdRouteRouteChildren)

interface ApplicationRouteRouteChildren {
  ApplicationIdRouteRoute: typeof ApplicationIdRouteRouteWithChildren
  ApplicationIndexRoute: typeof ApplicationIndexRoute
}

const ApplicationRouteRouteChildren: ApplicationRouteRouteChildren = {
  ApplicationIdRouteRoute: ApplicationIdRouteRouteWithChildren,
  ApplicationIndexRoute: ApplicationIndexRoute,
}

const ApplicationRouteRouteWithChildren =
  ApplicationRouteRoute._addFileChildren(ApplicationRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  publicRouteRoute: publicRouteRouteWithChildren,
  MerchantRouteRoute: MerchantRouteRouteWithChildren,
  ApplicationRouteRoute: ApplicationRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
